import { configureStore } from "@reduxjs/toolkit";
import { useDispatch as useAppDispatch, useSelector as useAppSelector } from "react-redux";
import reducers from "./reducers";

const store = configureStore({
    reducer: reducers,
    middleware (getDefaultMiddleware) {
        // return getDefaultMiddleware().concat(apiPersistModelMiddleware)
        return getDefaultMiddleware();
    }
});

const { dispatch } = store;

const useDispatch = () => useAppDispatch();
const useSelector = useAppSelector;

export { dispatch, store, useDispatch, useSelector };

